(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/models/game-definitions.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/models/game-definitions.js'); (function(Backbone, _, svs) {
  'use strict';

  svs.tipset.models.GameDefinitions = Backbone.Model.extend({
    defaults: {
      productName: 'Stryktipset',
      numberOfMatches: 13,
      rowPrices: [1],
      hasRAndU: true,
      hasSportkryss: true,
      hasTTT: true,
      multiDraws: [1, 5, 10],
      maxSystemSize: 41472,
      logoClass: 'logo-stryk',
      htmlClass: 'stryktipset',
      apiName: 'STRYK',
      apiNameLong: 'stryktipset',
      hasSpelanalys: true
    },

    initialize: function() {
      this.set('limits', { rows: 41472 });
    },

    getMarketplaceLimits: function(id) {
      switch (id) {
        case 1:
        case 2:
          return 60000;
        case 23:
        case 24:
        case 25:
        case 28:
          return 20000;
        default:
          return 0;
      }
    },

    getAPIName: function(id) {
      if (typeof id === 'string') {
        id = parseInt(id, 10);
      }
      switch (id) {
        case 1:
          return 'STRYK';
        case 2:
          return 'ITA';
        case 23:
          return 'T8STRYK';
        case 24:
          return 'T8EXTRA';
        case 25:
          return 'T8';
        case 28:
          return 'POWERPLAY';
        default:
      }
      return 'STRYK';
    },

    getProductId: function(productName) {
      switch (productName) {
        case 'STRYK':
          return 1;
        case 'ITA':
          return 2;
        case 'T8STRYK':
          return 23;
        case 'T8EXTRA':
          return 24;
        case 'T8':
          return 25;
        case 'POWERPLAY':
          return 28;
        default:
      }
      return 1;
    },

    hasWeekPicker: function() {
      var isInCompetitionMode = !!(
        svs.tipset.models.competition &&
        svs.tipset.models.competition.getCompetitionMode()
      );
      var hasMarketplaceAcc = !!(
        svs.components.marketplace &&
        svs.components.marketplace.accountSelector &&
        svs.components.marketplace.accountSelector.helpers.getCurrentAccount()
      );
      return (
        this.get('multiDraws').length > 1 &&
        !isInCompetitionMode &&
        !hasMarketplaceAcc
      );
    },

    hasSportkryss: function() {
      var hasMarketplaceAcc = !!(
        svs.components.marketplace &&
        svs.components.marketplace.accountSelector &&
        svs.components.marketplace.accountSelector.helpers.getCurrentAccount()
      );

      return (
        this.get('hasSportkryss') &&
        ((!svs.core.detect.feature('ft-marketplace-sportkryss') &&
          !hasMarketplaceAcc) ||
          svs.core.detect.feature('ft-marketplace-sportkryss'))
      );
    },

    hasReduceMode: function() {
      return this.get('hasReduceMode');
    }
  });
})(Backbone, _, svs);

 })(window);